<script>
import { cloneDeep } from 'lodash';
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
    components: {
        MaskedInput
    },
    props: {
        tableData: Array,
        loading: Boolean,
        canAct: Boolean,
        cycles: Array
    },
    data(){
        return {
            actNow: false,
            form: {
                id: 0,
                cycle: this.$store.state.data.cycle,
                annualTarget: "",
                actualAccomplishment: "",
                remarks: ""
            },
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
        }
    },
    methods: {
        completeAnnualTarget(row = null){
            if(!row){
                if(this.tableData.findIndex(i => i.cycle == this.form.cycle) > -1) return this.showToast('Cannot input multiple year', 'error');
                let data = cloneDeep(this.form);
                data.annualTarget = this.getExactAmt(this.form.annualTarget)
                data.actualAccomplishment = this.getExactAmt(this.form.actualAccomplishment);
                this.$emit('save', data);
                this.actNow = false;
            }else{
                let idx = false;
                this.tableData.map(i => {
                    if(i.id != row.id && i.cycle == row.cycle) idx = true;
                }) 
                if(idx) return this.showToast('Cannot input multiple year', 'error');
                row.editMode = false;
                let data = cloneDeep(row);
                data.annualTarget = this.getExactAmt(row.annualTargetCopy)
                data.actualAccomplishment = this.getExactAmt(row.actualAccomplishmentCopy);
                this.$emit('save', data);
            }
        },
        addMore(){
            this.actNow = true;
            this.tableData.map(item => item.editMode = false);
        },
        removeThis(row){
            this.$emit('delete', row)
        },
        editThis(row){
            row.annualTargetCopy = row.annualTarget.toString()
            row.actualAccomplishmentCopy = row.actualAccomplishment.toString()
            row.editMode = true;
        }
    },
}
</script>

<template>
    <table class="table-bordered">
        <thead>
            <tr>
                <th class="text-center px-5">Year</th>
                <th class="text-center px-5">Target</th>
                <th class="text-center px-5">Actual</th>
                <th class="text-center px-5">Remarks</th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="loading">
                <td colspan="100%">
                    <div class="d-flex justify-content-center align-items-center my-5">
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </td>
            </tr>
            <tr v-if="!tableData.length && !loading && !actNow">
                <td colspan="100%" class="px-1 py-1 text-center">No data found.</td>
            </tr>
            <template v-else>
                <tr v-for="x in tableData" :key="x.id">
                    <template v-if="!x.editMode">
                        <td class="text-center">{{x.cycle}}</td>
                        <td class="text-center">{{x.annualTarget}}</td>
                        <td class="text-center">{{x.actualAccomplishment}}</td>
                        <td class="text-center">{{x.remarks}}</td>
                        <td v-if="canAct">
                            <a href="javascript:void(0);" class="text-success font-size-16 me-1" @click="editThis(x)"><i class="bx bx-edit"></i></a>
                            <a href="javascript:void(0);" class="text-danger font-size-16" @click="removeThis(x)"><i class="bx bx-trash"></i></a>
                        </td>
                    </template>
                    <template v-else>
                        <td>
                            <select class="form-select form-select-sm text-center" v-model="x.cycle">
                                <option v-for="x in cycles" :key="x">{{x}}</option>
                            </select>
                        </td>
                        <td>
                            <masked-input type="text" class="form-control form-control-sm text-center" v-model="x.annualTargetCopy" :mask="currencyMask" />
                        </td>
                        <td>
                            <masked-input type="text" class="form-control form-control-sm text-center" v-model="x.actualAccomplishmentCopy" :mask="currencyMask"/>
                        </td>
                        <td>
                            <textarea rows="1" class="form-control form-control-sm text-center" v-model="x.remarks"/>
                        </td>
                        <td>
                            <a href="javascript:void(0);" class="text-success font-size-16 me-1" @click="completeAnnualTarget(x)"><i class="bx bx-check"></i></a>
                            <a href="javascript:void(0);" class="text-danger font-size-16" @click="x.editMode = false"><i class="bx bx-x"></i></a>
                        </td>
                    </template>
                </tr>
            </template>
            <tr v-if="canAct && !actNow">
                <td colspan="100%" class="text-center">
                    <a href="javascript:void(0);" class="hover-underlined" @click="addMore">Add More</a>
                </td>
            </tr>
            <template v-if="actNow">
                <tr>
                    <td>
                        <select class="form-select form-select-sm text-center" v-model="form.cycle">
                            <option v-for="x in cycles" :key="x">{{x}}</option>
                        </select>
                    </td>
                    <td>
                        <masked-input type="text" class="form-control form-control-sm text-center" v-model="form.annualTarget" :mask="currencyMask"/>
                    </td>
                    <td>
                        <masked-input type="text" class="form-control form-control-sm text-center" v-model="form.actualAccomplishment" :mask="currencyMask"/>
                    </td>
                    <td>
                        <textarea rows="1" class="form-control form-control-sm text-center" v-model="form.remarks"/>
                    </td>
                    <td>
                        <a href="javascript:void(0);" class="text-success font-size-16 me-1" @click="completeAnnualTarget()"><i class="bx bx-check"></i></a>
                        <a href="javascript:void(0);" class="text-danger font-size-16" @click="actNow = false"><i class="bx bx-x"></i></a>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>